<template>
    <label class="mt-checkbox">
        <input type="checkbox"
               v-bind="{name}"
               :checked="value"
               @change="$emit('input', $event.target.checked)">
        <slot></slot>
        <span></span>
    </label>
</template>

<script>
    export default {
        props: ['name', 'value']
    };
</script>